import React, { useState } from 'react';
import { Table, Button, Card, Collapse, Form, Row, Col } from 'react-bootstrap';
import { FaToggleOn, FaToggleOff, FaStar, FaChevronDown, FaChevronRight, FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const OPCOES_PIX_TIPO = { C: 'CPF/CNPJ', T: 'Telefone', E: 'E-mail', A: 'Aleatória' };
const OPCOES_TIPO_CONTA = { 1: 'Corrente', 2: 'Poupança' };

const PIX_TIPO_OPTIONS = [
  { value: '', label: '-- Nenhum --' },
  { value: 'C', label: 'CPF/CNPJ' },
  { value: 'T', label: 'Telefone' },
  { value: 'E', label: 'E-mail' },
  { value: 'A', label: 'Aleatória' },
];

const TIPO_CONTA_OPTIONS = [
  { value: '', label: '-- Nenhum --' },
  { value: '1', label: 'Corrente' },
  { value: '2', label: 'Poupança' },
];

const FORM_INICIAL = {
  codigo_grupo_empresa: '',
  portador_boleto: '',
  portador_sinal_incorp: '',
  projeto_int_vendas: '',
  portador_int_vendas: '',
  cliente_empresa: '',
  conta_despesa_comissao: '',
  responsavel: '',
  responsavel_tipo: '',
  portador_cartao: '',
  portador_deposito: '',
  sinal_banco: '',
  sinal_agencia: '',
  sinal_conta: '',
  sinal_tipo_conta: '',
  fundo_cred: '',
  fundo_perc: '',
  conta_redutor_venda_desconto: '',
  portador_boleto_antecipa: '',
  pix_tipo: '',
  pix_chave: '',
  email_imobiliaria: '',
};

const GridIntVendas = ({ codigoFamilia, intVendas, onRecarregar }) => {
  const [expandedGe, setExpandedGe] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(FORM_INICIAL);
  const [salvando, setSalvando] = useState(false);

  const toggleExpand = (ge) => setExpandedGe(expandedGe === ge ? null : ge);

  const handleToggleStatus = async (item) => {
    try {
      await api.toggleStatusIntVendas({
        codigo_familia: codigoFamilia,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
      });
      toast.success('Status atualizado!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao alterar status';
      toast.error(msg);
    }
  };

  const handleMarcarPrincipal = async (item) => {
    if (!window.confirm(`Marcar GE ${item.codigo_grupo_empresa} como principal?`)) return;
    try {
      await api.marcarPrincipalIntVendas({
        codigo_familia: codigoFamilia,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
      });
      toast.success('GE marcado como principal!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao marcar principal';
      toast.error(msg);
    }
  };

  const handleAbrirForm = () => {
    setForm(FORM_INICIAL);
    setShowForm(true);
  };

  const handleChange = (campo, valor) => {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  };

  const handleIncluir = async () => {
    if (!form.codigo_grupo_empresa) {
      toast.error('Informe um GE.');
      return;
    }
    setSalvando(true);
    try {
      const toIntOrNull = (v) => (v !== '' && v != null ? Number(v) : null);
      const toStrOrNull = (v) => (v !== '' && v != null ? v : null);
      await api.incluirIntVendasConfig({
        codigo_familia: codigoFamilia,
        codigo_grupo_empresa: Number(form.codigo_grupo_empresa),
        portador_boleto: toIntOrNull(form.portador_boleto),
        portador_sinal_incorp: toIntOrNull(form.portador_sinal_incorp),
        projeto_int_vendas: toIntOrNull(form.projeto_int_vendas),
        portador_int_vendas: toIntOrNull(form.portador_int_vendas),
        cliente_empresa: toIntOrNull(form.cliente_empresa),
        conta_despesa_comissao: toIntOrNull(form.conta_despesa_comissao),
        responsavel: toIntOrNull(form.responsavel),
        responsavel_tipo: toIntOrNull(form.responsavel_tipo),
        portador_cartao: toIntOrNull(form.portador_cartao),
        portador_deposito: toIntOrNull(form.portador_deposito),
        sinal_banco: toStrOrNull(form.sinal_banco),
        sinal_agencia: toStrOrNull(form.sinal_agencia),
        sinal_conta: toStrOrNull(form.sinal_conta),
        sinal_tipo_conta: toIntOrNull(form.sinal_tipo_conta),
        fundo_cred: toIntOrNull(form.fundo_cred),
        fundo_perc: form.fundo_perc !== '' ? Number(form.fundo_perc) : null,
        conta_redutor_venda_desconto: toIntOrNull(form.conta_redutor_venda_desconto),
        portador_boleto_antecipa: toIntOrNull(form.portador_boleto_antecipa),
        pix_tipo: toStrOrNull(form.pix_tipo),
        pix_chave: toStrOrNull(form.pix_chave),
        email_imobiliaria: toStrOrNull(form.email_imobiliaria),
      });
      toast.success('Integração vendas incluída com sucesso!');
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir integração vendas';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir a integração vendas do GE ${item.codigo_grupo_empresa}?`)) return;
    try {
      await api.excluirIntVendasConfig({
        codigo_familia: codigoFamilia,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
      });
      toast.success('Integração vendas excluída!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir integração vendas';
      toast.error(msg);
    }
  };

  const Field = ({ label, value }) => {
    if (value == null || value === '') return null;
    return (
      <span className="mr-4">
        <small className="text-muted">{label}:</small> <strong>{value}</strong>
      </span>
    );
  };

  return (
    <Card className="mb-3" style={{ overflow: 'hidden' }}>
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Integração Vendas</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>GE *</Form.Label>
                  <Form.Control type="number" value={form.codigo_grupo_empresa} onChange={(e) => handleChange('codigo_grupo_empresa', e.target.value)} placeholder="Código GE" />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Port. Boleto</Form.Label>
                  <Form.Control type="number" value={form.portador_boleto} onChange={(e) => handleChange('portador_boleto', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Port. Sinal</Form.Label>
                  <Form.Control type="number" value={form.portador_sinal_incorp} onChange={(e) => handleChange('portador_sinal_incorp', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Projeto</Form.Label>
                  <Form.Control type="number" value={form.projeto_int_vendas} onChange={(e) => handleChange('projeto_int_vendas', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Port. IntVendas</Form.Label>
                  <Form.Control type="number" value={form.portador_int_vendas} onChange={(e) => handleChange('portador_int_vendas', e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Cli. Empresa</Form.Label>
                  <Form.Control type="number" value={form.cliente_empresa} onChange={(e) => handleChange('cliente_empresa', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Cta Desp. Com.</Form.Label>
                  <Form.Control type="number" value={form.conta_despesa_comissao} onChange={(e) => handleChange('conta_despesa_comissao', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Responsável</Form.Label>
                  <Form.Control type="number" value={form.responsavel} onChange={(e) => handleChange('responsavel', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Resp. Tipo</Form.Label>
                  <Form.Control type="number" value={form.responsavel_tipo} onChange={(e) => handleChange('responsavel_tipo', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Port. Cartão</Form.Label>
                  <Form.Control type="number" value={form.portador_cartao} onChange={(e) => handleChange('portador_cartao', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Port. Depósito</Form.Label>
                  <Form.Control type="number" value={form.portador_deposito} onChange={(e) => handleChange('portador_deposito', e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Sinal Banco</Form.Label>
                  <Form.Control maxLength={3} value={form.sinal_banco} onChange={(e) => handleChange('sinal_banco', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Sinal Agência</Form.Label>
                  <Form.Control maxLength={10} value={form.sinal_agencia} onChange={(e) => handleChange('sinal_agencia', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Sinal Conta</Form.Label>
                  <Form.Control maxLength={20} value={form.sinal_conta} onChange={(e) => handleChange('sinal_conta', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Tipo Conta</Form.Label>
                  <Form.Control as="select" value={form.sinal_tipo_conta} onChange={(e) => handleChange('sinal_tipo_conta', e.target.value)}>
                    {TIPO_CONTA_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Fundo Cred</Form.Label>
                  <Form.Control type="number" value={form.fundo_cred} onChange={(e) => handleChange('fundo_cred', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Fundo %</Form.Label>
                  <Form.Control type="number" step="0.01" value={form.fundo_perc} onChange={(e) => handleChange('fundo_perc', e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Cta Redutor Desc</Form.Label>
                  <Form.Control type="number" value={form.conta_redutor_venda_desconto} onChange={(e) => handleChange('conta_redutor_venda_desconto', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Port. Bol. Antecipa</Form.Label>
                  <Form.Control type="number" value={form.portador_boleto_antecipa} onChange={(e) => handleChange('portador_boleto_antecipa', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>PIX Tipo</Form.Label>
                  <Form.Control as="select" value={form.pix_tipo} onChange={(e) => handleChange('pix_tipo', e.target.value)}>
                    {PIX_TIPO_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>PIX Chave</Form.Label>
                  <Form.Control maxLength={50} value={form.pix_chave} onChange={(e) => handleChange('pix_chave', e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Email Imobiliária</Form.Label>
                  <Form.Control maxLength={150} value={form.email_imobiliaria} onChange={(e) => handleChange('email_imobiliaria', e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-2">
              <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button size="sm" variant="secondary" onClick={() => setShowForm(false)} disabled={salvando}>
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflow: 'auto' }}>
          <Table striped bordered hover size="sm" className="mb-0">
            <thead>
              <tr>
                <th style={{ width: 30 }}></th>
                <th>GE</th>
                <th>Apelido</th>
                <th>Status</th>
                <th>Principal</th>
                <th>Port.Boleto</th>
                <th>Port.Sinal</th>
                <th>Projeto</th>
                <th>Port.IntVendas</th>
                <th>Cli.Empresa</th>
                <th>Cta.Desp.Com.</th>
                <th>Responsável</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {intVendas.length === 0 && (
                <tr>
                  <td colSpan={13} className="text-center text-muted">
                    Nenhum registro cadastrado
                  </td>
                </tr>
              )}
              {intVendas.map((item) => {
                const ge = item.codigo_grupo_empresa;
                const isExpanded = expandedGe === ge;
                return (
                  <React.Fragment key={ge}>
                    <tr>
                      <td style={{ cursor: 'pointer', textAlign: 'center' }} onClick={() => toggleExpand(ge)}>
                        {isExpanded ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />}
                      </td>
                      <td>{ge}</td>
                      <td>{item.apelido}</td>
                      <td>{item.status === 'A' ? 'Ativo' : 'Inativo'}</td>
                      <td>{item.principal === 'S' ? 'Sim' : 'Não'}</td>
                      <td>{item.portador_boleto}</td>
                      <td>{item.portador_sinal_incorp}</td>
                      <td>{item.projeto_int_vendas}</td>
                      <td>{item.portador_int_vendas}</td>
                      <td>{item.cliente_empresa}</td>
                      <td>{item.conta_despesa_comissao}</td>
                      <td>{item.responsavel}{item.responsavel_tipo != null ? ' (' + item.responsavel_tipo + ')' : ''}</td>
                      <td>
                        <Button
                          size="sm"
                          variant={item.status === 'I' ? 'success' : 'warning'}
                          className="mr-1"
                          title={item.status === 'I' ? 'Ativar' : 'Inativar'}
                          onClick={() => handleToggleStatus(item)}
                        >
                          {item.status === 'I' ? <FaToggleOn /> : <FaToggleOff />}
                        </Button>
                        <Button size="sm" variant="outline-primary" className="mr-1" title="Principal" onClick={() => handleMarcarPrincipal(item)}>
                          <FaStar />
                        </Button>
                        <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                    <Collapse in={isExpanded}>
                      <tr>
                        <td colSpan={13} className="bg-light p-2">
                          <div className="d-flex flex-wrap">
                            <Field label="Sigla" value={item.sigla} />
                            <Field label="Port. Cartão" value={item.portador_cartao} />
                            <Field label="Port. Depósito" value={item.portador_deposito} />
                            <Field label="Sinal Banco" value={item.sinal_banco} />
                            <Field label="Sinal Agência" value={item.sinal_agencia} />
                            <Field label="Sinal Conta" value={item.sinal_conta} />
                            <Field label="Sinal Tipo Conta" value={item.sinal_tipo_conta != null ? (OPCOES_TIPO_CONTA[item.sinal_tipo_conta] || item.sinal_tipo_conta) : null} />
                            <Field label="Fundo Cred" value={item.fundo_cred} />
                            <Field label="Fundo %" value={item.fundo_perc} />
                            <Field label="Cta Redutor Vda Desc" value={item.conta_redutor_venda_desconto} />
                            <Field label="Port. Boleto Antecipa" value={item.portador_boleto_antecipa} />
                            <Field label="PIX Tipo" value={item.pix_tipo != null ? (OPCOES_PIX_TIPO[item.pix_tipo] || item.pix_tipo) : null} />
                            <Field label="PIX Chave" value={item.pix_chave} />
                            <Field label="Email Imobiliária" value={item.email_imobiliaria} />
                          </div>
                        </td>
                      </tr>
                    </Collapse>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridIntVendas;
